import React, {useEffect, useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {Formik} from 'formik';
import moment from 'moment';
import {useSimpleDateRangeContext} from '../../../SimpleDateRangeContext';
import {applyFilter} from '../../../../../../utils/prepareApplyFilter';
import FieldRadiobutton from '../../../../_common/components/FieldRadiobutton';
import ClearIcon from '../../../../_common/components/ClearIcon';
import {FilterDatePicker} from '../../../../_common/components/FieldDatepicker';
import styles from '../../../pages/styles.module.scss';

export function SimpleDateRangeFilters({}) {
  const intl = useIntl();
  const prefix = 'dashboard-page-simpleDateRange';
  const simpleDateRangeContext = useSimpleDateRangeContext();
  const simpleDateRangeProps = useMemo(() => {
    return {
      queryParams: simpleDateRangeContext.simpleQueryParams,
      setQueryParams: simpleDateRangeContext.setSimpleQueryParams,
    };
  }, [simpleDateRangeContext]);
  useEffect(() => simpleDateRangeProps.setQueryParams({simpleDateRange, fromDate, toDate}), []);

  const initialDateRange = window.localStorage.getItem('simpleDateRange') || 'last 6 months';
  const initialFromDate = window.localStorage.getItem('fromDate') || '';
  const initialToDate = window.localStorage.getItem('toDate') || '';
  const [simpleDateRange, setSimpleDateRange] = useState(initialDateRange);
  const [fromDate, setFromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);

  const getCommonProps = (handleSubmit, setFieldValue) => {

    return {
      fieldId: 'simpleDateRange',
      onChange: ({value}) => {
        handleSubmit();
        setFieldValue('simpleDateRange', value);
        setSimpleDateRange(value);
        window.localStorage.setItem('simpleDateRange', value);
        if (value !== 'free dates') {
          onChangeDate('fromDate', '', setFieldValue, handleSubmit);
          onChangeDate('toDate', '', setFieldValue, handleSubmit);
        }
      },
      customContainerStyles: 'd-flex justify-content-center',
    };
  };
  const onChangeDate = (fieldID, date, setFieldValue, handleSubmit) => {
    const value = date ? moment(date).format('YYYY-MM-DD') : '';
    setFieldValue(fieldID, value);
    if (fieldID === 'fromDate') {
      setFromDate(value);
      window.localStorage.setItem('fromDate', value);
    } else {
      setToDate(value);
      window.localStorage.setItem('toDate', value);
    }
    handleSubmit();
  };

  return (
    <Formik
      initialValues={{simpleDateRange, fromDate, toDate}}
      onSubmit={(values) => applyFilter(values, simpleDateRangeProps)}
      enableReinitialize={false}
    >
      {({handleSubmit, setFieldValue}) => (
        <form onSubmit={handleSubmit}>
          <div className={styles.timePeriodContainer}>
            <FieldRadiobutton
              value={'current year'}
              label={intl.formatMessage({id: `${prefix}-currentYear`, defaultMessage: 'Current year'})}
              {...getCommonProps(handleSubmit, setFieldValue)}
            />
            <FieldRadiobutton
              value={'last 6 months'}
              label={intl.formatMessage({id: `${prefix}-last6Months`, defaultMessage: 'Last 6 months'})}
              {...getCommonProps(handleSubmit, setFieldValue)}
            />
            <FieldRadiobutton
              value={'last 12 months'}
              label={intl.formatMessage({id: `${prefix}-last12Months`, defaultMessage: 'Last 12 months'})}
              {...getCommonProps(handleSubmit, setFieldValue)}
            />
            <div className={'d-flex justify-content-between align-items-center'}>
              <FieldRadiobutton
                value={'free dates'}
                label={intl.formatMessage({id: `${prefix}-freeDates`, defaultMessage: 'Free dates'})}
                {...getCommonProps(handleSubmit, setFieldValue)}
              />
              <div className={styles.datesContainer}>
                <div className={'position-relative w-200px mx-2'}>
                  <FilterDatePicker
                    placeholder={intl.formatMessage({
                      id: 'filter-placeholder-fromDate',
                      defaultMessage: 'From date'
                    })}
                    value={fromDate}
                    onChange={date => onChangeDate('fromDate', date, setFieldValue, handleSubmit)}
                    maxDate={toDate}
                    disabled={simpleDateRange !== 'free dates'}
                  />
                  <ClearIcon onClick={() => onChangeDate('fromDate', '', setFieldValue, handleSubmit)}/>
                </div>
                <div className={'position-relative w-200px mx-2'}>
                  <FilterDatePicker
                    placeholder={intl.formatMessage({id: 'filter-placeholder-toDate', defaultMessage: 'To date'})}
                    value={toDate}
                    onChange={date => onChangeDate('toDate', date, setFieldValue, handleSubmit)}
                    minDate={fromDate}
                    disabled={simpleDateRange !== 'free dates'}
                  />
                  <ClearIcon onClick={() => onChangeDate('toDate', '', setFieldValue, handleSubmit)}/>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}

export default SimpleDateRangeFilters;